var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_246",
    transform: "scale(0.0185185)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_246",
    width: 54,
    height: 54,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAADjUlEQVRoBd1az4sTMRQeQfxLvPoXuEtF0KsouAgi6w+oZtY9i+vBPXgpiPgDtCiyBY+eBHFFxIJgIREUkXpadYb2JHvx6CnypY1Oh2TmZSbdDikMM80kL9837+XlvSRR5PEnZbRvNLh6KOVsPeVxNxGsn/L4R8rj3USwP7jwjLLpuy7qog3aeoRSX5QiI1gr4fHTRMS/Uh7LKhfaQsZIsNZCSQ6Hpw+kgrVTwXaqEClsA5mCtdFH/U/vICER8dmUs3EhuIqam5XJxujLAVq1qqNBfHA6NiqZ2yxousmiT/RdDXVJq1SsrSQ8/l0VXN12qm+xtlIC0+11yuNOXWAe23fc0Btqy/7m/pSznkdQnkyY9YDNAJlW1ExSemyyHo1FrlbDzM+maTezhKNonvlpTeXuVIeiXHqB97tz7bD0cd29viQf3mzJZ7ePy1dbJ+Wn7VWZcGbTjLUc3pI0FZTNUz5I2WQ8uXVUvn9+xpkgMOdG0uzfSUSRU3UugrCB8lne6xyTw3eXrFoyDRNrhKJiP0KY5JNAkawHN5blx5fnHMixsTG2VAFtTjumL1MExvc7jEMncoK1Z2wQaQI1SvcNvkweNEc2S8F2ZlIe5EAm7ZjKyoDM4z3GHNVjgss/rSHBM5GglFGIZOXg629vnZL3Npacpg14y6wc2zO4KGJQXZ3M15WYBvT17UX5aPMImRymAorWwEWZ42SNotjFazCme1VikPXlzQUJB0GRgTqYxE0Y8mXgFE0XXkgN8gLwnwLK1E6XvXh8giQD/SBC0e2K72w9wmpScaVibdYl9vn1KpkYwi8i1m5UFkKVCapL7PuHy2RiiC3L8OC9CrESzn5SKtvq1CUGuRQZqIPxaMORLQcnmCIWMEkNTPUooEztsmUUGbpOtl3B8y5MEauzQREDp3CJhWuKAToPbHos3t0PrpC9opO7X/wEfZ5MzGmCDjakCjYIDjZtQVK2l4nmt/4k0by/sUweW4g6nBNNEAt2aQDmGORiDrQW5PIbiAW7YKqciNo0L470dfowz7vXJW4Qw68so54nobltSoBYsNtIIBfkxp+yR5Br1kkBW4bvtlULcmpua+SJAe3cKm6uK3KhHof4r7nADrDo8YZ7kEeONEE1FUwOV9oG81zKMbeSTgZooFXvwR3ry34IFVuGdhAzSxDTAvI5JKt1NhAbc3Q2S04/K5K5w87TTY89P+z8F9V60GHS+s8sAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoge);
export default __webpack_public_path__ + "static/media/doge.8518bfd45d7bc27055dd3a00b093a54c.svg";
export { ForwardRef as ReactComponent };